// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Button } from 'seek-style-guide/react';

import { save } from 'src/store/saveSearch/saveSearch';
import { omit } from 'lodash';

type SaveSearchHandlerProps = {
  locale: Locale,
  query: SearchParams,
  location?: UrlLocation
};

type SaveSearchHandler = (
  saveSearchHandlerProps: SaveSearchHandlerProps
) => void;

type Props = {
  locale: Locale,
  query: SearchParams,
  location?: UrlLocation,
  saveSearchHandler: SaveSearchHandler,
  children: React$Element<*>,
  component?: string | Function,
  saveSearchPosition?: string
};

const mapStateToProps = ({ location, search, results }) => ({
  locale: location.locale,
  query: search.query,
  location: results.location
});

const mapDispatchToProps = {
  saveSearchHandler: save
};

class SaveSearchButton extends Component<Props> {
  props: Props;

  saveSearch = () => {
    const {
      query,
      location,
      saveSearchHandler,
      locale,
      saveSearchPosition
    } = this.props;
    saveSearchHandler({ locale, query, location, saveSearchPosition });
  };

  render() {
    const { component: Wrapper = Button, ...restProps } = this.props;
    const rootProps = omit(restProps, [
      'locale',
      'query',
      'location',
      'saveSearchHandler',
      'saveSearchPosition'
    ]);

    return <Wrapper {...rootProps} onClick={this.saveSearch} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveSearchButton);
